import { gql } from '@apollo/client';

export const CampaignTestLeadsQuery = gql`
  query CampaignTestLeads($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      shortId
      companyId
      testLeads {
        id
        phone
        firstName
        source
        isDnc
        vendorId
      }
    }
  }
`;

export const CampaignCreateTestLeadMutation = gql`
  mutation CampaignCreateTestLead($createTestLeadData: CreateTestLeadInput!) {
    createTestLead(createTestLeadData: $createTestLeadData) {
      id
      phone
      firstName
      source
      isDnc
    }
  }
`;

export const CampaignTestLeadsResetLeadMutation = gql`
  mutation CampaignTestLeadsResetLead($leadResetData: LeadResetInput!) {
    leadReset(leadResetData: $leadResetData) {
      message
    }
  }
`;

export const CampaignTestLeadsAdvanceFlowMutation = gql`
  mutation CampaignTestLeadsAdvanceFlow($leadAdvanceFlowData: LeadAdvanceFlowInput!) {
    leadAdvanceFlow(leadAdvanceFlowData: $leadAdvanceFlowData) {
      message
    }
  }
`;
